module.exports = __webpack_public_path__ + "static/media/shrutika.40b871de.png";